export default __webpack_public_path__ + "static/rollers-b9d3bc021581d97eadfae4a414809b1f.png";